export const ALLOWED_EMAIL_DOMAIN = "positiverecruitment.io";

export const CANDIDATE_STATUSES = [
  "new", "to_contact", "contacted", "interested", "follow_up_later",
  "interview", "offer", "hired", "rejected", "not_interested", "resigned", "archived",
] as const;
export type CandidateStatus = typeof CANDIDATE_STATUSES[number];

export const STATUS_LABELS: Record<CandidateStatus, string> = {
  new: "Nowy",
  to_contact: "Do kontaktu",
  contacted: "Skontaktowany",
  interested: "Zainteresowany",
  follow_up_later: "Follow-up później",
  interview: "Rozmowa",
  offer: "Oferta",
  hired: "Zatrudniony",
  rejected: "Odrzucony",
  not_interested: "Nie zainteresowany",
  resigned: "Zrezygnował",
  archived: "Zarchiwizowany",
};

export const STATUS_COLORS: Record<CandidateStatus, string> = {
  new: "bg-blue-500/20 text-blue-300 border-blue-500/40",
  to_contact: "bg-amber-500/20 text-amber-300 border-amber-500/40",
  contacted: "bg-cyan-500/20 text-cyan-300 border-cyan-500/40",
  interested: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
  follow_up_later: "bg-violet-500/20 text-violet-300 border-violet-500/40",
  interview: "bg-fuchsia-500/20 text-fuchsia-300 border-fuchsia-500/40",
  offer: "bg-lime-500/20 text-lime-300 border-lime-500/40",
  hired: "bg-green-600/30 text-green-300 border-green-500/40",
  rejected: "bg-red-500/20 text-red-300 border-red-500/40",
  not_interested: "bg-zinc-500/20 text-zinc-300 border-zinc-500/40",
  resigned: "bg-orange-500/20 text-orange-300 border-orange-500/40",
  archived: "bg-zinc-700/40 text-zinc-400 border-zinc-600/40",
};


export const STATUS_ROW_TINT: Record<CandidateStatus, string> = {
  new: "",
  to_contact: "bg-amber-500/5 hover:bg-amber-500/10",
  contacted: "",
  interested: "bg-emerald-500/5 hover:bg-emerald-500/10",
  follow_up_later: "bg-amber-500/5 hover:bg-amber-500/10",
  interview: "bg-emerald-500/[0.07] hover:bg-emerald-500/10",
  offer: "bg-emerald-500/10 hover:bg-emerald-500/15",
  hired: "bg-emerald-500/15 hover:bg-emerald-500/20",
  rejected: "bg-red-500/5 hover:bg-red-500/10",
  not_interested: "bg-red-500/5 hover:bg-red-500/10",
  resigned: "bg-red-500/[0.07] hover:bg-red-500/10",
  archived: "opacity-60",
};

export const TASK_STATUSES = ["open", "done", "snoozed", "cancelled"] as const;
export const TASK_TYPES = [
  "follow_up", "call", "email", "linkedin_message", "update_profile", "review_classification", "other",
] as const;

export const TASK_TYPE_LABELS: Record<string, string> = {
  follow_up: "Follow-up",
  call: "Telefon",
  email: "Email",
  linkedin_message: "LinkedIn",
  update_profile: "Aktualizacja profilu",
  review_classification: "Przegląd klasyfikacji",
  other: "Inne",
};

export const SYSTEM_POOLS = [
  "python", "golang", "ruby", "js-ts", "data-eng", "cloud-devops",
  "backend", "frontend", "fullstack", "team-lead",
] as const;
